import {ButtonPrimary, ButtonSecondary, Checkbox, Grid, ModalBase} from "pac-ux-components";
import React, {useEffect} from "react";
import {useCookies} from "react-cookie";

function PaymentMethodModal(props) {
    const [saving, setSaving] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(false);
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookies.idToken
    }

    const [allPaymentMethods, setAllPaymentMethods] = React.useState([]);
    const [pspPaymentMethods, setPspPaymentMethods] = React.useState([]);
    const [originalPspPaymentMethods, setOriginalPspPaymentMethods] = React.useState([]);


    async function getPaymentMethods() {
        const response = await fetch(apiRoot + '/backoffice/payment-methods?page=0&size=100', {headers: apiHeaders});
        const data = await response.json();
        setAllPaymentMethods(data.content);
    }

    async function getPaymentMethodsForPsp() {
        const response = await fetch(apiRoot + '/backoffice/payment-service-providers/' + props.psp + '/payment-methods?page=0&size=100', {headers: apiHeaders});
        const data = await response.json();
        let payMethodArray = {};
        for (const pspPayMethod of data.content) {
            payMethodArray[pspPayMethod.id] = pspPayMethod.name;
        }
        const payMethodArrayCopy = JSON.parse(JSON.stringify(payMethodArray));
        setOriginalPspPaymentMethods(payMethodArrayCopy);
        setPspPaymentMethods(payMethodArray);

    }

    async function save() {
        try {
            for (const eachPayMethod of allPaymentMethods) {
                if (pspPaymentMethods[eachPayMethod.id] && !originalPspPaymentMethods[eachPayMethod.id]) {

                    //assign the payment method to the psp
                    const response = await fetch(apiRoot + '/backoffice/payment-service-providers/' + props.psp + '/payment-methods/' + eachPayMethod.id + '/assign', {
                        method: 'POST', headers: apiHeaders,
                    });
                    if (!response.ok) {
                        throw new Error('Failed to assign payment method');
                    }
                }
                if (originalPspPaymentMethods[eachPayMethod.id] && !pspPaymentMethods[eachPayMethod.id]) {
                    //unassign the payment method from the psp
                    const response = await fetch(apiRoot + '/backoffice/payment-service-providers/' + props.psp + '/payment-methods/' + eachPayMethod.id + '/unassign', {
                        method: 'POST', headers: apiHeaders,
                    });
                    if (!response.ok) {
                        throw new Error('Failed to unassign payment method');
                    }
                }
            }

        } catch (error) {
            setError(error);
            setSaving(false);
        }
    }

    useEffect(() => {
        // Define an async function inside useEffect
        const fetchData = async () => {
            await getPaymentMethods();
            await getPaymentMethodsForPsp();
            setSaving(false);
            setLoading(false);// Only set loading to false after the data is fetched
        };
        fetchData();
    }, []);

    return (<div>
        <ModalBase
            style={{display: (props.display === true) ? 'block' : 'none'}}
        >
            <form
                onSubmit={async (e) => {
                    e.preventDefault();
                    setSaving(true);

                    e.stopPropagation();
                    return;
                }}
            >
                <div style={{width: '619px', height: '200px', paddingLeft: 33, fontFamily: 'Inter'}}>
                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 24,
                        fontWeight: '700',
                        marginTop: 38,
                        paddingBottom: 52,
                        wordWrap: 'break-word'
                    }}>Payment Methods
                    </div>
                    {loading ?
                        <div style={{textAlign: 'center', padding: 16}}>Loading...</div>
                     : null}
                    <Grid
                        columns="repeat(3, auto)"
                    >
                        {allPaymentMethods.map((item) => (
                            <div style={{width: 200, paddingRight: 32, display: "flex", alignItems: "center"}}
                                 key={item.id}>
                                <Checkbox
                                    marked={pspPaymentMethods[item.id] ? "selected" : "unselected"}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            pspPaymentMethods[item.id] = item.name;
                                        } else {
                                            delete pspPaymentMethods[item.id];
                                        }
                                        setPspPaymentMethods({...pspPaymentMethods});
                                    }}
                                />
                                <span style={{marginLeft: 8}}>{item.name}</span>

                            </div>
                        ))}
                    </Grid>
                </div>

                <div style={{
                    float: 'right', marginBottom: 32, marginRight: 32,
                }}>

                    <ButtonSecondary
                        onClick={() => {
                            props.closeModal()
                        }}
                        style={{
                            marginRight: 32,
                        }}>Cancel</ButtonSecondary>

                    <ButtonPrimary
                        type='submit'
                        disabled={saving}
                        onClick={async () => {
                            setSaving(true);
                            await save();
                            props.closeModal();
                        }}
                    >Save</ButtonPrimary>
                </div>
            </form>
        </ModalBase>
    </div>);
}

export default PaymentMethodModal;